import { render, staticRenderFns } from "./DashboardClientContent.vue?vue&type=template&id=90296f1a&scoped=true"
import script from "./DashboardClientContent.vue?vue&type=script&lang=js"
export * from "./DashboardClientContent.vue?vue&type=script&lang=js"
import style0 from "./DashboardClientContent.vue?vue&type=style&index=0&id=90296f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90296f1a",
  null
  
)

export default component.exports